import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  () => ({
    mainBox: {
      padding: '20px',
      margin: 'auto',
    },
  }),
  { index: 1 },
);

export default useStyles;
